import React from 'react';
import type { MessageActionType } from '../types';
import { EndUserComponent } from '@aurora/shared-types/pages/enums';
import CopyMessageLink from '../CopyMessageLink/CopyMessageLink';
import type { TopicMessage } from '@aurora/shared-generated/types/graphql-schema-types';
import { VisibilityScope } from '@aurora/shared-generated/types/graphql-schema-types';

/**
 * Action to copy a message's link.
 *
 * @author Vaibhav Chawla
 *
 * @constructor
 */
const MessageActionCopyLink: React.FC<React.PropsWithChildren<MessageActionType>> = ({
  message
}) => {
  const isArchived = (message as TopicMessage).visibilityScope === VisibilityScope.Archived;

  return (
    !isArchived && (
      <CopyMessageLink message={message} componentId={EndUserComponent.MESSAGE_ACTION_COPY_LINK} />
    )
  );
};

export default MessageActionCopyLink;
